import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="w-full max-w-md bg-white border border-border rounded-sm p-10 text-center">
        <div className="w-16 h-16 rounded-sm bg-secondary flex items-center justify-center mx-auto"><XCircle className="w-9 h-9 text-muted-foreground" /></div>
        <h1 className="mt-5 font-heading font-800 text-2xl">Pagamento cancelado</h1>
        <p className="mt-2 text-muted-foreground">Nenhuma cobrança foi feita. Seu anúncio continua ativo e gratuito.</p>
        <Button className="mt-6 w-full bg-obsidian hover:bg-blaze text-white rounded-sm" onClick={() => navigate("/painel")} data-testid="cancel-back-btn">Voltar ao painel</Button>
      </div>
    </div>
  );
}
